import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.reduce.js";
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from './image/Telegram-2.png';
import _imports_1 from './image/QQ-2.png';
import _imports_2 from './image/Skype-2.png';
import _imports_3 from './image/丝瓜-2.png';
const _hoisted_1 = {
  key: 0,
  class: "connect"
};
import { getWmsFormData } from "@/api/wms.js";
export default {
  __name: 'index',
  setup(__props) {
    const connect = ref([]);
    const open = type => {
      if (connect.value[type].url) {
        window.open(connect.value[type].url, "agconnect");
      }
    };
    getWmsFormData("wms-form-recruit-connect").then(res => {
      // 防止和旧数据报错
      if (res.status == 200 && res.data.length > 0 && res.data[0].constructor == Object) {
        console.log("联系方式", res);
        let l = res.data.filter(x => x.domain.includes(location.hostname));
        connect.value = l.reduce((pre, curr) => {
          pre[curr.key] = curr;
          return pre;
        }, {});
      }
    });
    return (_ctx, _cache) => {
      return Object.keys(_unref(connect)).length > 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [_cache[8] || (_cache[8] = _createElementVNode("li", {
        class: "connect-title"
      }, [_createElementVNode("div", null, "成为代理")], -1)), _unref(connect).telegram ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        class: "item",
        onClick: _cache[0] || (_cache[0] = $event => open('telegram'))
      }, [_cache[4] || (_cache[4] = _createElementVNode("div", null, [_createElementVNode("img", {
        src: _imports_0,
        alt: "",
        srcset: ""
      })], -1)), _createTextVNode(" " + _toDisplayString(_unref(connect).telegram.text), 1)])) : _createCommentVNode("", true), _unref(connect).qq ? (_openBlock(), _createElementBlock("li", {
        key: 1,
        class: "item",
        onClick: _cache[1] || (_cache[1] = $event => open('qq'))
      }, [_cache[5] || (_cache[5] = _createElementVNode("div", null, [_createElementVNode("img", {
        src: _imports_1,
        alt: "",
        srcset: ""
      })], -1)), _createTextVNode(" " + _toDisplayString(_unref(connect).qq.text), 1)])) : _createCommentVNode("", true), _unref(connect).skype ? (_openBlock(), _createElementBlock("li", {
        key: 2,
        class: "item",
        onClick: _cache[2] || (_cache[2] = $event => open('skype'))
      }, [_cache[6] || (_cache[6] = _createElementVNode("div", null, [_createElementVNode("img", {
        src: _imports_2,
        alt: "",
        srcset: ""
      })], -1)), _createTextVNode(" " + _toDisplayString(_unref(connect).skype.text), 1)])) : _createCommentVNode("", true), _unref(connect).sigua ? (_openBlock(), _createElementBlock("li", {
        key: 3,
        class: "item",
        onClick: _cache[3] || (_cache[3] = $event => open('sigua'))
      }, [_cache[7] || (_cache[7] = _createElementVNode("div", null, [_createElementVNode("img", {
        src: _imports_3,
        alt: "",
        srcset: ""
      })], -1)), _createTextVNode(" " + _toDisplayString(_unref(connect).sigua.text), 1)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }
};